/**
 * We take the approach of organizing each “cast member” in a scene within its own file.
 * This is a choice and isn’t required, but it does isolate internal changes/enhancements
 * to these specific “characters.”
 */
import {Group, BoxGeometry, EdgesGeometry, EllipseCurve, BufferGeometry, LineBasicMaterial, Line,  Vector3, MeshBasicMaterial,  FlatShading, Mesh, LineSegments} from 'three'
/**
 * The use of a JavaScript “class” is also a design choice.
 */

class Masks {
    constructor() {
      this.group = new Group()
      this.group.materials = []

      this.geometry = new BoxGeometry(.5,5,8,1,1,1)
      this.geometry.scale(.04 , .06, .057)
      this.edges = new EdgesGeometry(this.geometry)
      this.lineMaterial = new LineBasicMaterial({color: 0xFFFFFF});
      this.group.materials.push(this.lineMaterial)
      this.lines = new LineSegments(this.edges, this.lineMaterial)
      this.maskMaterial = new MeshBasicMaterial({color: 0x84C8ED, shading: FlatShading})
      this.group.materials.push(this.maskMaterial)
      this.mask = new Mesh(this.geometry, this.maskMaterial)
      this.group.add(this.lines)
      this.group.add(this.mask)

      const points1 = []
      points1.push(new Vector3(.015,-.05,-.23));
      points1.push(new Vector3(.015,-.05,0));
      points1.push(new Vector3(.015,-.05,.23));
      this.geometry = new BufferGeometry().setFromPoints(points1);
      this.maskLines = new Line(this.geometry, this.lineMaterial);
      this.group.add(this.maskLines)

      const points2 = []
      points2.push(new Vector3(.015,0.045,-.23));
      points2.push(new Vector3(.015,0.045,0));
      points2.push(new Vector3(.015,0.045,.23));
      this.geometry = new BufferGeometry().setFromPoints(points2);
      this.maskLines = new Line(this.geometry, this.lineMaterial);
      this.group.add(this.maskLines)

      const points3 = []
      points3.push(new Vector3(-.015,-.05,-.23));
      points3.push(new Vector3(-.015,-.05,0));
      points3.push(new Vector3(-.015,-.05,.23));
      this.geometry = new BufferGeometry().setFromPoints(points3);
      this.maskLines = new Line(this.geometry, this.lineMaterial);
      this.group.add(this.maskLines)

      const points4 = []
      points4.push(new Vector3(-.015,0.045,-.23));
      points4.push(new Vector3(-.015,0.045,0));
      points4.push(new Vector3(-.015,0.045,.23));
      this.geometry = new BufferGeometry().setFromPoints(points4);
      this.maskLines = new Line(this.geometry, this.lineMaterial);
      this.group.add(this.maskLines)


      const curve1 = new EllipseCurve(
          0,0,
          .11,.11,
          0, 2* Math.PI,
          true,
          0
      );
      this.geometry = new BufferGeometry().setFromPoints(curve1.getPoints(50));
      this.curveMaterial = new LineBasicMaterial({color: 0xFFFFFF});
      this.group.materials.push(this.curveMaterial)
      this.circle1 = new Line(this.geometry, this.curveMaterial);
      this.circle1.rotation.y = Math.PI/2 
      this.circle1.scale.set(3.9,1.3,3.9)
      this.group.add(this.circle1);

      this.group.scale.set(1.205,1.215,1.215);
      }
}
export default Masks;